
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/(sites)/[siteType]",
      function () {
        return require("private-next-pages/(sites)/[siteType]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/(sites)/[siteType]"])
      });
    }
  